module.exports = __webpack_public_path__ + "static/img/1-07-1.4eb38e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/newsDetail/1-07-1.png
// module id = Otn5
// module chunks = 1